import { Injectable } from "@angular/core";
import { CrudService } from "src/app/components/shared/cruds/crud.service";
import { EmpresasDTO } from "src/app/models/empresas.dto";

@Injectable({ providedIn: "root" })
export class EmpresasService extends CrudService<EmpresasDTO> {
  protected controller: string = "settings/empresas/";
}
